module.exports = __webpack_public_path__ + "static/media/kids.f370c18d.png";